const {
  VUE_APP_OSS_BASE_URL,
  VUE_APP_WX_BASE_URL,
  VUE_APP_DOWNLOAD_URL,
  VUE_APP_API_BASE_URL,
  VUE_APP_RYAPI_BASE_URL,
  VUE_APP_SLIDER_URL,
  VUE_APP_V_CONSOLE,
  NODE_ENV,
  VUE_APP_TRACK_APP_IDS,
} = process.env;

// 基础配置
const baseConfig = {
  apiUrl: VUE_APP_API_BASE_URL,
  ossUrl: VUE_APP_OSS_BASE_URL,
  wxBaseUrl: VUE_APP_WX_BASE_URL,
  commonUrl: VUE_APP_DOWNLOAD_URL,
  ryapiUrl: VUE_APP_RYAPI_BASE_URL,
  sliderUrl:VUE_APP_SLIDER_URL,
  vConsole:VUE_APP_V_CONSOLE,
  trackAppIds:VUE_APP_TRACK_APP_IDS
};

// 获取当前域名
const currentDomain = typeof window !== 'undefined' ? window.location.hostname : '';

// 域名对应的配置映射表
// 可以根据实际需求添加更多域名和对应的配置
const domainConfigMap = {
  // 冀时办
  'activity.szjiyun.com': {
    ryapiUrl: 'https://ryapi.szjiyun.com',
    apiUrl: 'https://ryapi.szjiyun.com/entryapi',
    ossUrl: 'https://mediacloud-pub.szjiyun.com',
    sliderUrl: 'https://ryapi.szjiyun.com/voteapi',
    wxBaseUrl: 'https://commonapi.szjiyun.com'
    // 其他未设置的配置项会使用baseConfig中的值
  },
  // 可以继续添加更多域名配置...
};

// 根据当前域名获取对应的配置，如果没有匹配的域名则使用基础配置
const dynamicConfig = domainConfigMap[currentDomain] && NODE_ENV === 'production' ? {
  ...baseConfig,
  ...domainConfigMap[currentDomain]
} : baseConfig;
export const apiUrl = dynamicConfig



// WEBPACK FOOTER //
// ./src/common/js/base.js